export default __webpack_public_path__ + "static/media/bathroom-Up_AQP-INDOOR-OBLOGA-2X-12,5-MM.a0675834.jpg";